import '@/i18n/template/api/export.js'
import api from './index'
import { trimStringField } from '../util'

export const ExportType = {
  MobilePayment: '1',
  MerchantPayment: '2',
  DepositAccrualSettlement: '3',
  CustPaymentHistory: '4',
  CustTransferHistory: '5',
  CustPointHistory: '6',
  GrabRedPackageHistory: '7',
  CustInfo: '8',
  MerchantInfo: '9',
  MerchantOrderInfo: '10',
  TrustyCoinsHistory: '11',
  AccountHistory: '12',
  CashHistory: '13',
  CustomerException: '14',
  MerchantException: '15',
  MerchantPaymentHistory: '16',
  MerchantRealNameHistory: '17',
  CustomerRealNameHistory: '18',
  // 账单明细导出
  MeterBillDetail: '19',
  // 结算明细
  MeterBillSettleDetail: '20',
  // 可疑监控数据清单
  MonitorEventDataList: '21',
  // teller商户报表按商户
  AcquiringBusinessByMerchant: '22',
  // teller商户报表按地区
  AcquiringBusinessByLoaction: '23',
  // Village Disburse
  VillageDisburseHistory: '24',
  VillageDisburseHistoryDetail: '36',
  // Village Payment
  VillagePaymentHistory: '25',
  // teller Daylyreport
  DailyReport: '26',
  ElectricityBillTownshipTotal: '27',
  ElectricityBillDailyReportByTownship: '28',
  ElectricityBillbyLastPaymentDueList: '29',
  ElectricityBillbyTownshipReceivingReport: '30',
  AccountListByProduct: '31',
  MPortal_OrderList: '32',
  InquiryInternalAccount: '33',
  CustomerLiveHistory: '34',
  MerchantLiveHistory: '35',
  RedPacketReport: '37',
  FinanicalTransferForAllAccount: '38',
  EmeraldLoanSettlement: '39',
  EmeraldLoanBill: '40',
  // teller report TransactionListByTranaction&Channel
  TransactionListByTranactionChannel: '41',
  FinanicalTransaction: '42',
  DailyHomeRentalCharges: '45',
  DailyIncomeOfWater: '46',
  DailyIncomeOfDevelopAndSecuity: '47',
  MothlyRentalCharges: '48',
  MothlyIncomeOfOthers: '49',
  MothlyBalanceDueListForHomeRental: '50',
  DailyIncomeOfShopRental: '51',
  DailyOtherChargesIncomeOfShopRenter: '52',
  MothlyIncomeOfShopRental: '53',
  MothlyOtherChargesIcome: '54',
  MothlyDueListForShopRental: '55',
  BatchOpenAccountDetail: '57',
  MobileTopUpServiceDetail: '58',
  FixedDepositSettlement: '59',
  MerchantSettlementSum: '60',
  MerchantSettlementDetail: '61',
  TransactionListByProduct: '62',
  GLTransactionListByAccountCode: '63',
  FXProfitAndLossStatement: '67',
  DailyHomeRentalAndWater: '68',
  MonthReportByTwonship: '69',
  DailyReportByLedgerNo: '70',
  DailyReportByTownship: '71',
  DailyReportByLastDate: '72',
  InquireTransactionList: '',
  BatchOpenPaydayLoanAccountDetail: '73',
  PaydayLoanCreditLimit: '74',
  PaydayLoanLoanBalance: '75',
  PaydayLoanDailyReport: '76',
  PaydayLoanDetailReport: '77'
}

export function exportFile(busTp, param) {
  return api.post({
    url: 'manager/export/addExportTask',
    data: {
      busTp,
      exportParam: JSON.stringify(trimStringField(param))
    }
  })
}
